import {formatDate} from '../utils/date-utils';
import {Table} from '@trussworks/react-uswds';

import {renderCurrency} from '../utils/utils';

const renderSummaryCaseTypesRow = (scCase) => {
  return (
    <tr key="case-type-row" id="case-type-row">
      <th scope="row">Case Type</th>
      <td style={{whiteSpace: 'pre-wrap'}}>{scCase.typeOfCase}</td>
    </tr>
  );
};

const renderCaseStatus = (params) => {
  if (params) return `${params.value && params.value.toLowerCase() === 'open' ? 'Open' : 'Closed'}`;
};

const renderSummarySubjectsRow = (scCase) => {
  if (['NOPV', 'NOA', 'WL', 'Other'].includes(scCase.caseType) && scCase.proposedSubjectEt) {
    return (
      <tr key="subjects-row" id="subjects-row">
        <th scope="row">Item Subject(s)</th>
        <td style={{whiteSpace: 'pre-wrap'}}>{scCase.proposedSubjectEt.replace(/\|/g, '\n')}</td>
      </tr>
    );
  }
};

const renderProposedPenaltyRow = (scCase) => {
  if (['NOPV', 'Other'].includes(scCase.caseType) && scCase.cpInd === 'Yes') {
    return (
      <tr key="penalty-row" id="penalty-row">
        <th scope="row">Proposed Civil Penalty</th>
        <td id="proposed-penalty">{renderCurrency(scCase.proposedPenalties)}</td>
      </tr>
    );
  }
};

const renderSummaryTotalPaidRow = (scCase) => {
  if (scCase.cpInd === 'Yes' && ['NOPV', 'Other'].includes(scCase.caseType)) {
    return (
      <tr key="total-paid-row" id="total-paid-row">
        <th scope="row">Collected Civil Penalty</th>
        <td id="total-paid">{renderCurrency(scCase.collected)}</td>
      </tr>
    );
  }
};

const renderSummaryAssessedPenaltyRow = (scCase) => {
  if (scCase.assessedPenalties > 0 && ['NOPV', 'Other'].includes(scCase.caseType)) {
    return (
      <tr key="assessed-penalty-row" id="assessed-penalty-row">
        <th scope="row">Assessed Civil Penalty</th>
        <td id="assessed-penalty">{renderCurrency(scCase.assessedPenalties)}</td>
      </tr>
    );
  }
};

const renderNoticeActionEtRow = (scCase) => {
  if (['NOA', 'NOPV', 'WL', 'Other'].includes(scCase.caseType)) {
    return (
      <tr key="proposed-actions-row" id="proposed-actions-row">
        <th scope="row">Proposed Actions</th>
        <td>{scCase.noticeActionEt}</td>
      </tr>
    );
  }
};

const renderProposedTotalItemsRow = (scCase) => {
  if (['NOA', 'NOPV', 'WL'].includes(scCase.caseType)) {
    return (
      <tr key="proposed-total-items-row" id="proposed-total-items-row">
        <th scope="row">Total Proposed Item(s)</th>
        <td>{scCase.proposedTotalItems}</td>
      </tr>
    );
  }
};

const renderSummaryReducedReasonsRow = (scCase) => {
  if (['NOPV'].includes(scCase.caseType) && scCase.reducedReason) {
    return (
      <tr key="reduced-reason-row" id="reduced-reasons-row">
        <th scope="row">Basis for Penalty Reduction</th>
        <td style={{whiteSpace: 'pre-wrap'}}>{scCase.reducedReason}</td>
      </tr>
    );
  }
};

const renderWithdrawnAllegationsRow = (scCase) => {
  if (['NOPV', 'NOA'].includes(scCase.caseType) && scCase.withdrawAllegationEt) {
    {
      return (
        <tr key="withdrawn-allegation-row" id="withdrawn-allegation-row">
          <th scope="row">Withdrawn Allegation(s)</th>
          <td style={{whiteSpace: 'pre-wrap'}}>{scCase.withdrawAllegationEt.replace(/\|/g, '\n')}</td>
        </tr>
      );
    }
  }
};

const renderWithdrawReasonRow = (scCase) => {
  if (['NOPV', 'NOA'].includes(scCase.caseType) && scCase.withdrawReason) {
    return (
      <tr key="withdrawn-reason-row" id="withdrawn-reason-row">
        <th scope="row">Basis for Withdrawn</th>
        <td>{scCase.withdrawReason}</td>
      </tr>
    );
  }
};

const renderWithdrawDtRow = (scCase) => {
  if (['CAO', 'PSO'].includes(scCase.caseType) && scCase.withdrawDt) {
    return (
      <tr key="withdraw-dt-row" id="withdraw-dt-row">
        <th scope="row">Case Withdrawn?</th>
        <td> {scCase.withdrawInd ? 'Withdrawn as of ' + formatDate(scCase.withdrawDt) : 'No'}</td>
      </tr>
    );
  }
};

const renderSummaryComplianceOrderRow = (scCase) => {
  if (scCase.coInd === 'Yes') {
    if (scCase.consentOrderDt || scCase.finalOrderDt) {
      return (
        <tr key="compliance-order-row" id="compliance-order-row">
          <th scope="row">Compliance Order</th>
          <td>{scCase.coInd === 'Yes' ? 'Yes' : 'No'}</td>
        </tr>
      );
    }
  }
};

const renderSummaryConsentOrderDateRow = (scCase) => {
  if (scCase.consentOrderDt) {
    return (
      <tr key="consent-order-date-row" id="consent-order-date-row">
        <th scope="row">Consent Order Date</th>
        <td>{formatDate(scCase.consentOrderDt)}</td>
      </tr>
    );
  }
};

const renderSummaryClosedDateRow = (scCase) => {
  if (scCase.caseStatus === 'CLOSED') {
    return (
      <tr key="closed-date-row" id="closed-date-row">
        <th scope="row">Date Closed</th>
        <td>{formatDate(scCase.closedDt)}</td>
      </tr>
    );
  }
};

const renderSummaryFinalOrderDateRow = (scCase) => {
  if (scCase.finalOrderDt) {
    return (
      <tr key="final-order-date-row" id="final-order-date-row">
        <th scope="row">Final Order Date</th>
        <td>{formatDate(scCase.finalOrderDt)}</td>
      </tr>
    );
  }
};

const renderLatestOrderTypeRow = (scCase) => {
  if (['NOPV', 'NOA', 'CAO', 'PSO'].includes(scCase.caseType) && scCase.latestOrderType) {
    return (
      <tr key="latest-order-type-row" id="latest-order-type-row">
        <th scope="row">Latest Order Type</th>
        <td>{scCase.latestOrderType}</td>
      </tr>
    );
  }
};

const renderLatestOrderDtRow = (scCase) => {
  if (['NOPV', 'NOA', 'CAO', 'PSO'].includes(scCase.caseType) && scCase.latestOrderDt) {
    return (
      <tr key="latest-order-date-row" id="latest-order-date-row">
        <th scope="row">Latest Order Date</th>
        <td>{formatDate(scCase.latestOrderDt)}</td>
      </tr>
    );
  }
};

const renderIncidentDetailRow = (scCase) => {
  if (scCase.incidentDetail) {
    return (
      <tr key="incident-detail-row" id="incident-detail-row">
        <th scope="row">30 Days Incident Report</th>
        <td>{scCase.incidentDetail}</td>
      </tr>
    );
  } else return;
};

const renderTableCaption = (table_alt_caption) => {
  if (table_alt_caption) {
    return table_alt_caption;
  } else
    return (
      <>
        <h4>Documents</h4>
        <p>
          Response options for NOPV and NOA cases are included in the enclosure &ldquo;Response Options for Pipeline
          Operators & Excavators in Enforcement Proceedings&rdquo;, this document is also available on the PHMSA
          Pipeline Enforcement webpage. All other case types include response details in the issued notice or order (as
          appropriate).
        </p>
        <p>The corresponding document format at the time the case was opened may differ from document displayed.</p>
      </>
    );
};

const renderDocumentTable = (case_documents, options) => {
  options = options || {};
  options.is_excavation = Object.hasOwn(options, 'is_excavation') ? options.is_excavation : false;
  const table_title = Object.hasOwn(options, 'alt_title') ? options.alt_title : 'File';
  const table_alt_caption = Object.hasOwn(options, 'alt_caption') ? options.alt_caption : undefined;

  if (case_documents.length > 0) {
    // assign the public URL path to each document
    // the test will fail if process.env.GATSBY_DOCUMENT_SERVER_PATH is undefined
    case_documents.forEach((doc) => {
      doc.publicUrl = `${process.env.GATSBY_DOCUMENT_SERVER_PATH}/${doc.cpf}/${doc.name}`;
    });
    return (
      <>
        {renderTableCaption(table_alt_caption)}

        <Table bordered>
          <thead>
            <tr key="files-header">
              <th scope="col">{table_title}</th>
            </tr>
          </thead>
          <tbody id="case-documents-table">
            {case_documents.map((doc) => (
              <tr key={doc.publicUrl}>
                <td>
                  <a href={doc.publicUrl} target="_blank" rel="noopener noreferrer">
                    {doc.name}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );
  } else {
    return (
      <>
        <h4>Documents</h4>
        <p className="text-italic text-base">There are no documents available for this case.</p>
      </>
    );
  }
};

export {
  renderDocumentTable,
  renderCaseStatus,
  renderSummaryCaseTypesRow,
  renderProposedPenaltyRow,
  renderSummarySubjectsRow,
  renderNoticeActionEtRow,
  renderProposedTotalItemsRow,
  renderWithdrawnAllegationsRow,
  renderWithdrawReasonRow,
  renderWithdrawDtRow,
  renderIncidentDetailRow,
  renderSummaryTotalPaidRow,
  renderSummaryAssessedPenaltyRow,
  renderSummaryReducedReasonsRow,
  renderSummaryComplianceOrderRow,
  renderSummaryConsentOrderDateRow,
  renderSummaryClosedDateRow,
  renderSummaryFinalOrderDateRow,
  renderLatestOrderTypeRow,
  renderLatestOrderDtRow,
};
